// extracted by mini-css-extract-plugin
module.exports = {"Audio":"BookPage_Audio__19Cyu","TitrImg":"BookPage_TitrImg__kZKiD","PdfTitrImg":"BookPage_PdfTitrImg__3nhbj"};